import { RestrictionCategoryId } from '@/models/restriction/category/id';
import { RestrictionDetailsModalRestrictionsDetailsCardsProps } from '../props';
import styles from './styles.module.scss';
import { FormGroup, Image, ToolTip } from '@starsoft/common/components';
import useTranslation from 'next-translate/useTranslation';
import { WalletService } from '@starsoft/common/services';

export default function RestrictionDetailsModalRestrictionsDetailsAmount({
  restriction,
}: RestrictionDetailsModalRestrictionsDetailsCardsProps) {
  const { t } = useTranslation('common');
  return (
    <FormGroup
      label={t('restriction_details_amount_label')}
      action={
        <ToolTip
          titleComponent={
            <p>{t(`common:${restriction?.categoryId}_category_description`)}</p>
          }
        >
          <i className="fa-solid fa-circle-info" />
        </ToolTip>
      }
    >
      <p className={styles.container__label}>
        {([
          RestrictionCategoryId.Deposit?.toString(),
          RestrictionCategoryId.Withdrawal?.toString(),
          RestrictionCategoryId.Spend?.toString(),
          RestrictionCategoryId.Stake?.toString(),
        ].includes(restriction?.categoryId?.toString()) && (
          <div className={styles.container}>
            <Image
              src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
                restriction?.coin?.image ?? 'brl.svg'
              }`}
              alt={restriction?.coin?.name}
              width={24}
              height={24}
              className={styles.container__image}
            />
            <p className={styles.container__label}>
              {WalletService.maskCurrency({
                amount: restriction?.maxValue,
                coin: restriction?.coin,
              })}
            </p>
          </div>
        )) || (
          <p className={styles.container__label}>
            {WalletService.maskCurrency({
              amount: restriction?.maxValue,
              hideSymbol: true,
            })}
          </p>
        )}
      </p>
    </FormGroup>
  );
}
